"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = operate;
var _big = _interopRequireDefault(require("./big.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function operate(numberOne, numberTwo, operation) {
  var one = (0, _big["default"])(numberOne || '0');
  var two = (0, _big["default"])(numberTwo || '0');
  if (operation === '+') {
    return one.plus(two).toString();
  }
  if (operation === '-') {
    return one.minus(two).toString();
  }
  if (operation === 'x') {
    return one.times(two).toString();
  }
  if (operation === '÷') {
    return one.div(two).toString();
  }
  throw Error("Unknown operation '".concat(operation, "'"));
}